import { IAuftrag } from '../../types/Types';



interface ThisProps {
  textToCopy: string;
  textToDisplay: string;
}

/**
 * @author noone
 */
const ButtonCopyComponent: React.FC<ThisProps> = (props) => {

  const copyAdresse = () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(props.textToCopy)
        //.then(() => alert("Text kopiert!"))
        .catch(err => console.error("Fehler beim Kopieren:", err));
    }
  }

  return (
    <>
      <button className="btn btn-light" onClick={() => copyAdresse()}>
        <i className="bi bi-copy"></i> {props.textToDisplay}
      </button>
    </>
  );

}

export default ButtonCopyComponent;